module.exports = `${require.publicPath}icon12.daf1b475.png`;